import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import { convertDate } from "../../../utils";
import { rouletteResultsAdminContext } from "../../../context/Admin/RouletteResultsAdminContext/RouletteResultsAdminContext";

const RouletteResultsAdmin = () => {
  const {
    rouletteResultsItems,
    search,
    setSearch,
    appliedSearch,
    handleSearchResults,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    handleGetRouletteResultsItemList,
  } = useContext(rouletteResultsAdminContext);

  useEffect(() => {
    handleGetRouletteResultsItemList();
  }, [pageNumber, limit, appliedSearch]);

  const otherCalculate = (_items) => {
    if (!_items) return 0;

    return (
      _items?.all -
      (_items?.cleaning +
        _items?.moving +
        _items?.carwash +
        _items?.appliance +
        _items?.dc +
        _items?.ac +
        _items?.carpet)
    );
  };

  return (
    <>
      <SiteTitle title="برندگان گردونه" />

      <CardLayout>
        <form className="input-group mb-3" onSubmit={handleSearchResults}>
          <input className="form-control" value={search} onChange={(event) => setSearch(event.target.value)}
            placeholder="عنوان گردونه، جایزه، نام یا موبایل برنده" aria-label="جستجوی برندگان گردونه" />
          <button className="btn btn-primary" type="submit">جستجو</button>
        </form>
        {isEmpty(rouletteResultsItems) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                initialPage={pageNumber - 1}
                setPageNumber={setPageNumber}
                pageCount={Math.ceil(totalCount / limit)}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => { setPageNumber(1); setLimit(Number(e.target.value)); }}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه نتیجه</th>
                  <th>زمان ثبت</th>
                  <th>جایزه</th>
                  <th>گردونه</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>شماره موبایل</th>
                  <th>کل</th>
                  <th>نظافت</th>
                  <th>اسباب کشی</th>
                  <th>کارواش</th>
                  <th>لوازم خانگی</th>
                  <th>خشکشویی</th>
                  <th>کولرگازی</th>
                  <th>قالیشویی</th>
                  <th>سایر</th>
                </tr>
              </thead>
              <tbody>
                {rouletteResultsItems.map((_item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>{convertDate(_item.created)}</td>
                    <td>{_item?.item?.title}</td>
                    <td>{_item.roulette}</td>
                    <td>{_item?.user?.first_name}</td>
                    <td>{_item?.user?.last_name}</td>
                    <td>{_item?.user?.mobile}</td>
                    <td>{_item?.user?.order_count?.all}</td>
                    <td>{_item?.user?.order_count?.cleaning}</td>
                    <td>{_item?.user?.order_count?.moving}</td>
                    <td>{_item?.user?.order_count?.carwash}</td>
                    <td>{_item?.user?.order_count?.appliance}</td>
                    <td>{_item?.user?.order_count?.dc}</td>
                    <td>{_item?.user?.order_count?.ac}</td>
                    <td>{_item?.user?.order_count?.carpet}</td>
                    <td>{otherCalculate(_item?.user?.order_count)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>
    </>
  );
};

export default RouletteResultsAdmin;
